// Traducciones específicas para la página "Buscamos por ti" - Español
export const weSearchForYouEs = {
  hero: {
    title: 'Buscamos Tu Auto',
    description:
      '¿No encuentras el auto que buscas? Lo buscamos por ti y te avisamos cuando tengamos opciones que se ajusten a tus necesidades.',
  },
  form: {
    criteriaTitle: 'Criterios de Búsqueda',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Email',
    phone: 'Teléfono',
    brand: 'Marca',
    brandPlaceholder: 'Selecciona una marca',
    model: 'Modelo',
    modelPlaceholder: 'Selecciona un modelo',
    yearFrom: 'Año desde',
    yearTo: 'Año hasta',
    yearFromPlaceholder: 'Ej: 2018',
    yearToPlaceholder: 'Ej: 2023',
    maxMileage: 'Kilometraje máximo',
    maxMileagePlaceholder: 'Ej: 50000',
    maxOwners: 'Máximo de dueños',
    maxOwnersPlaceholder: 'Ej: 2',
    budget: 'Presupuesto',
    budgetPlaceholder: 'Ej: 15.000.000',
    message: 'Detalles adicionales',
    messagePlaceholder:
      'Cuéntanos más detalles sobre lo que buscas...',
    submit: 'Solicitar Búsqueda',
  },
  info: {
    howItWorksTitle: '¿Cómo Funciona Nuestro Servicio?',
    processTitle: 'Nuestro proceso',
    processList: {
      step1: 'Envías tu solicitud con los criterios específicos',
      step2: 'Recibimos tu requerimiento y lo registramos',
      step3: 'Iniciamos la búsqueda activa en nuestro mercado',
      step4: 'Te contactamos cuando encontremos opciones',
      step5: 'Coordinas la visita y evaluación del vehículo',
      step6: 'Realizas la compra si te convence',
    },
    advantagesTitle: 'Ventajas del servicio',
    advantagesList: {
      item1: 'Búsqueda personalizada según tus criterios',
      item2: 'Acceso a vehículos no publicados',
      item3: 'Evaluación previa de calidad',
      item4: 'Negociación profesional',
      item5: 'Sin costo adicional por el servicio',
      item6: 'Asesoría especializada',
    },
    directContactTitle: 'Contacto Directo',
    emailLabel: 'Email',
    phoneLabel: 'Teléfono',
    tipTitle: 'Consejo importante',
    tipText:
      'Mientras más específicos sean tus criterios, mejor podremos encontrar el vehículo ideal para ti. No dudes en agregar detalles adicionales en el mensaje.',
  },
  successMessage:
    '¡Solicitud de búsqueda enviada exitosamente! Te contactaremos pronto cuando tengamos opciones que se ajusten a tus criterios.',
  embed: {
    infoTitle: '¿Cómo funciona?',
    steps: [
      { title: 'Cuéntanos qué buscas', desc: 'Completa el formulario con tus preferencias y presupuesto.' },
      { title: 'Buscamos por ti', desc: 'Nuestro equipo busca en toda nuestra red de proveedores.' },
      { title: 'Te mostramos opciones', desc: 'Te presentamos las mejores alternativas encontradas.' },
      { title: 'Compra segura', desc: 'Gestionamos la compra con verificación mecánica incluida.' },
    ],
    benefitsTitle: 'Beneficios',
    benefits: ['Búsqueda personalizada', 'Acceso a red de proveedores', 'Verificación mecánica incluida', 'Garantía de satisfacción'],
  },
};

